import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { getUser } from 'store/user/storage'
import { selectWallet } from 'store/wallet/selectors'

export default function RequireAuth() {
  const [isLogined, setisLogined] = useState(true)
  const { address } = useSelector(selectWallet)
  const location = useLocation()

  useEffect(() => {
    setisLogined(!!getUser() || !!address)
  }, [address])

  return isLogined ? <Outlet /> : <Navigate to='/' state={{ from: location }} />
}
